import React, {PropTypes, Component} from 'react';
import logo from './logo.svg';
import './style.css';

class Home extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  render() {
    return (
      <div className="stevie">
        <div className="stevie-info">
          <h1>Ahoy. I'm Stevie.</h1>
          <p>I'm too busy making bad ass websites for other people to spend time working on this one.</p>
          <p><a href="stevie@stevie.co.nz" target="_blank">stevie@stevie.co.nz</a></p>
        </div>
        <div className="stevie-logo">
          <img src={logo} alt="Stevie Mayhew as a Pirate"/>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/components/Home.jsx